module.exports = __webpack_public_path__ + "img/zip.7d098bb5.png";